import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
const listeners = new Set();

export const selectedSession = () => localStorage.getItem("bf_session") || "";

/** Switch the whole app to another academic session. */
export const switchSession = (name) => {
  if (name) localStorage.setItem("bf_session", name);
  else localStorage.removeItem("bf_session");
  window.location.reload();
};

/**
 * The academic session every screen works in: the live one by default, or whichever past
 * session the user has selected. `rows` carries each session's lock state.
 */
export const useSession = () => {
  const [state, setState] = useState(cache || {
    current_session: "", sessions: [], rows: [], active: "", writable: true,
  });

  useEffect(() => {
    listeners.add(setState);
    if (!cache) {
      api.get("/sessions").then(({ data }) => {
        const picked = selectedSession();
        const row = data.rows.find((r) => r.name === picked)
          || data.rows.find((r) => r.name === data.active) || data.rows[0] || null;
        // pin the resolved session so every later request carries it explicitly
        if (row?.name) localStorage.setItem("bf_session", row.name);
        cache = {
          current_session: row?.name || data.active || "",
          sessions: data.rows.map((r) => r.name),
          rows: data.rows,
          active: data.active,
          writable: !!(row?.active || row?.unlocked),
        };
        listeners.forEach((l) => l(cache));
      }).catch(() => {});
    }
    return () => listeners.delete(setState);
  }, []);

  const saveSession = async (value) => {
    const { data } = await api.patch("/settings", { current_session: value });
    cache = null;
    localStorage.setItem("bf_session", data.current_session);
    return data;
  };

  return { ...state, saveSession, switchSession };
};
